<script setup lang="ts">
import { VIcon } from "@app/core";

const { query } = defineProps<{ query: string }>();

const emit = defineEmits<{ clear: [] }>();
</script>

<template>
  <button
    aria-label="Clear search filter"
    class="search-chip"
    type="button"
    @click="emit('clear')"
  >
    <VIcon
      class="search-chip__icon"
      icon="lucide:search"
      :size="12"
    />
    <span class="search-chip__text">{{ query }}</span>
    <VIcon
      class="search-chip__close"
      icon="lucide:x"
      :size="11"
      color="text-warning"
    />
  </button>
</template>

<style scoped>
.search-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3125rem;
  padding: 0.3125rem 0.5rem 0.3125rem 0.625rem;
  background-color: rgb(var(--color-primary, 14 165 233) / 0.1);
  border: 1px solid rgb(var(--color-primary, 14 165 233) / 0.25);
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition:
    background-color 150ms ease,
    border-color 150ms ease;
      border: 1.5px solid rgb(var(--color-base-300, 226 232 240) / 1);
@apply min-w-20 flex justify-between rounded-lg h-10;
}

@media (hover: hover) and (pointer: fine) {
  .search-chip:hover {
    background-color: rgb(var(--color-primary, 14 165 233) / 0.15);
    border-color: rgb(var(--color-primary, 14 165 233) / 0.4);
  }
}

.search-chip:active {
  transform: scale(0.97);
  transition: transform 100ms ease;
}

.search-chip__text {
  font-size: 1rem;
  font-weight: 500;
  color: rgb(var(--color-primary, 14 165 233) / 1);
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-chip__close {
  margin-left: 0.0625rem;
  transition: color 150ms ease;
}

.search-chip:hover .search-chip__close {
  @apply text-negative;
}
</style>
